// Components==============
import { motion } from 'framer-motion';
import React from 'react';
import { BarStatus } from 'screens/Flash/Flash';
import './ProgressBar.module.scss';
// =========================

const progressVariants = {
    initial: {
        x: '-100%',
    },
    status: (progress: number) => ({
        x: `-${100 - progress}%`,
    }),
};

type Props = {
    timeProps?: { variants: {}; animate: BarStatus };
    progressProps?: ProgressType[];
};

const Bar = ({
    timeProps,
    progressProps,
    exercise,
}: Props & { exercise?: ProgressType }) => {
    const getProgress = ({ total, done }: ProgressType) => (100 / total) * done;

    return (
        <div styleName="wrapper">
            <div styleName="inside">
                {!!timeProps && (
                    <motion.div
                        variants={timeProps.variants}
                        initial="initial"
                        animate={timeProps.animate}
                        styleName="progress"
                    />
                )}
                {!!progressProps && exercise && (
                    <>
                        <motion.div
                            variants={progressVariants}
                            initial="initial"
                            animate="status"
                            styleName="progress"
                            custom={getProgress(exercise)}
                        />
                        <p styleName="count">
                            {exercise.done}/{exercise.total}
                        </p>
                    </>
                )}
            </div>
        </div>
    );
};
export default function ProgressBar({ timeProps, progressProps }: Props) {
    return (
        <div styleName="container">
            {!!timeProps && <Bar timeProps={timeProps} />}
            {progressProps?.map((exercise, index) => (
                <Bar
                    progressProps={progressProps}
                    exercise={exercise}
                    key={index}
                />
            ))}
        </div>
    );
}
